<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-8">
        <h2 class="mb-2">{{ entry.title }}</h2>
        <p class="text-muted mb-4" v-html="entry.description"></p>
        <component :is="entry.component" v-model="selectedValue" />
        <div class="mt-4">
          <button
            class="btn btn-primary"
            :disabled="!selectedValue || saving"
            @click="submit"
          >
            {{ saving ? 'Saving…' : 'Save and Continue' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import { useStore } from 'vuex'
import SkuUniquenessSetting from '@/app/components/Utils/SkuUniquenessSetting.vue'

const REGISTRY = {
  UNIQUE_SKU: {
    title: 'How do you use Custom Labels (SKU)?',
    description:
      'This setting controls how eShopCommand imports and groups your eBay listings. ' +
      'Choose based on how you use the <strong>Custom Label (SKU)</strong> field. ' +
      'You can always change this later in <em>Command Center → My eBay → Custom Label (SKU).</em>',
    component: SkuUniquenessSetting,
    saveKey: 'UNIQUE_SKU'
  }
}

const props = defineProps({
  configKey: {
    type: String,
    required: true
  }
})

const store = useStore()
const selectedValue = ref(null)
const saving = ref(false)
const entry = computed(() => REGISTRY[props.configKey])

async function submit() {
  if (!selectedValue.value || saving.value) return
  saving.value = true
  try {
    await store.dispatch('eshop/saveStoreConfig', { key: entry.value.saveKey, val: selectedValue.value })
  } finally {
    saving.value = false
  }
}
</script>
